import { AttributesClass } from 'src/generated/operations.ts';
import { Accessory } from 'src/common/prepareAccessories.ts';

export const subtotalAccessories = <
    A extends AttributesClass,
>(
    accessories: Accessory<{ item: A }>[],
): number => accessories
    .reduce((acc, { price, qty }) => acc + (price * qty), 0);
